import camelCase from 'lodash.camelcase';
import snakeCase from 'lodash.snakecase';
import mapKeys from 'lodash.mapkeys';
import startsWith from 'lodash.startswith';
import deepObjectMap from "./deepObjectMap";

var deepMapKeys = function deepMapKeys(callback) {
  return deepObjectMap(function (object) {
    return mapKeys(object, function (value, key) {
      return callback(key);
    });
  });
};

var deepMapKeysToCamelCase = deepMapKeys(camelCase);
var deepMapKeysToSnakeCase = deepMapKeys(function (key) {
  return startsWith(key, '_') ? key : snakeCase(key);
});
export { deepMapKeys, deepMapKeysToCamelCase, deepMapKeysToSnakeCase };